<template>
  <b-container fluid class="form-signin signin">
    <confirmation-dialog hide-open-button message-title="Você já está logado" message-body="Tem certeza que deseja sair?"
      v-model="showLogoutDialog" @yes="logout" @no="$router.push({ name: 'dashboard' })" />
    <b-row align-h="center" no-gutters>
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-row>
          <b-col cols="12" class="mt-0 pt-0">
            <img id="logo" src="https://sistemclinupload.s3.amazonaws.com/logo.png" alt="SISTEMA CLIN" />
          </b-col>
          <b-col cols="12" class="mt-0 pt-0">
            <verify-email v-if="showVerifyEmail" @success="evOnVerifyEmailSuccess" />
            <online-sign-in v-if="showOnlineSignIn" :clients="clients" :email="email" @return="reset" />
            <offline-sign-in v-if="showOfflineSignIn" :user="user" @return="reset" />
          </b-col>
        </b-row>
        <b-row align-h="center" v-if="device_code()">
          <b-col cols="auto" class="mt-0 pt-0">
            <small>
              DISPOSITIVO:
              <span>{{ device_code() }}</span>
            </small>
          </b-col>
        </b-row>
        <div class="signin-alert-device">
          <p class="worksansr m-0 text-center">
            Acesse o sistema no Google Chrome.
          </p>
          <!-- <p class="worksansr m-0 text-center">
            <a href="">Saiba mais.</a>
          </p> -->
          <!-- <p
            class="worksansr m-0 mt-2 text-center v-warning"
            v-if="showBrowserInvalid"
          >
            Parece que você está utilizando o sistema em outro navegador. Para
            perfeita execução do sistema, por favor acesse no Google Chrome!
          </p> -->
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VerifyEmail from "../templates/SignIn/VerifyEmail.vue";
import OnlineSignIn from "../templates/SignIn/OnlineSignIn.vue";
import OfflineSignIn from "../templates/SignIn/OfflineSignIn.vue";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";
import api from "../services/api";

export default {
  name: "SignIn",

  components: {
    VerifyEmail,
    OnlineSignIn,
    OfflineSignIn,
    ConfirmationDialog,
  },

  data() {
    return {
      showBrowserInvalid: false,

      showLogoutDialog: false,

      showVerifyEmail: false,
      showOnlineSignIn: false,
      showOfflineSignIn: false,

      offline: false,
      email: "",
      cpf: "",
      clients: [],
      user: undefined,
    };
  },

  mounted() {
    this.showLogoutDialog = false;

    this.showVerifyEmail = false;
    this.showOnlineSignIn = false;
    this.showOfflineSignIn = false;

    this.offline = false;
    this.email = "";
    this.clients = [];
    this.user = undefined;

    this.isLoggedIn();
  },

  // created() {
  //   if (
  //     (navigator.userAgent.indexOf("Opera") ||
  //       navigator.userAgent.indexOf("OPR")) != -1
  //   ) {
  //     // Opera
  //     this.showBrowserInvalid = true;
  //   } else if (navigator.userAgent.indexOf("Edg") != -1) {
  //     // Edge
  //     this.showBrowserInvalid = true;
  //   } else if (navigator.userAgent.indexOf("Chrome") != -1) {
  //     // Chrome
  //     this.showBrowserInvalid = false;
  //   } else if (navigator.userAgent.indexOf("Safari") != -1) {
  //     // Safari
  //     this.showBrowserInvalid = true;
  //   } else if (navigator.userAgent.indexOf("Firefox") != -1) {
  //     // Firefox
  //     this.showBrowserInvalid = true;
  //   } else if (
  //     navigator.userAgent.indexOf("MSIE") != -1 ||
  //     !!document.documentMode == true
  //   ) {
  //     // IE -> if IE > 10
  //     this.showBrowserInvalid = true;
  //   } else {
  //     // unknown
  //     this.showBrowserInvalid = true;
  //   }
  // },

  methods: {
    device_code() {
      return localStorage.getItem("device_code");
    },

    async isLoggedIn() {
      try {
        const response = await api.get("/status/logged-in");
        const { error, logged_in } = response.data;

        const session = ["rest_home_id", "user", "permissions"].every((key) =>
          sessionStorage.getItem(key)
        );

        if (!error && logged_in && session) {
          this.showLogoutDialog = true;
        } else {
          await this.logout();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async logout() {
      try {
        await api.get("/status/logout");
        this.showVerifyEmail = true;
      } catch (error) {
        console.log(error);
      }
    },

    async reset() {
      this.showVerifyEmail = true;
      this.showOnlineSignIn = false;
      this.showOfflineSignIn = false;

      this.email = "";
      (this.clients = []), (this.offline = false);
    },

    async evOnVerifyEmailSuccess(event) {
      const { offline, clients, email, user } = event;

      this.showVerifyEmail = false;
      this.showOnlineSignIn = !offline;
      this.showOfflineSignIn = offline;

      this.offline = offline;
      this.clients = clients;
      this.email = email;
      this.user = user;
    },
  },
};
</script>

<style scoped>
#logo {
  padding: 20px;
  width: 100%;
  height: auto;
}
</style>